import { render, staticRenderFns } from "./NotificationListTableAction.vue?vue&type=template&id=d0790a16&scoped=true"
import script from "./NotificationListTableAction.vue?vue&type=script&lang=js"
export * from "./NotificationListTableAction.vue?vue&type=script&lang=js"
import style0 from "./NotificationListTableAction.vue?vue&type=style&index=0&id=d0790a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0790a16",
  null
  
)

export default component.exports